<template>
  <div class="home">
    <focus :focusData="focusData"> </focus>
    <!-- <div style="border: #ff0000 5px solid">{{ listData }}</div> -->
    <div class="mainBox">
      <van-tabs v-model="active" sticky scrollspy :ellipsis="false">
        <!-- module_type:1，候选人列表（投票列表）
        module_type:2，评选结果列表
        module_type:3，资讯列表
        module_type:4,底部banner -->
        <van-tab
          v-for="item in listData"
          :key="item.module_id"
          :title="item.module_name"
        >
          <votelist
            v-if="item.module_type === 1"
            :votelistData="item"
          ></votelist>
          <resultlist
            v-if="item.module_type === 2"
            :resultlistData="item"
          ></resultlist>
          <newslist
            v-if="item.module_type === 3"
            :newslistData="item"
          ></newslist>
        </van-tab>
      </van-tabs>
    </div>
    <banner-bar
      v-if="bottomBannerShow"
      :bottomBannerData="bottomBannerData"
    ></banner-bar>
  </div>
</template>

<script>
import axios from "axios";
import { Tab, Tabs, Toast, Sticky } from "vant"; //Sticky 粘性布局,tab菜单
import { getSignature } from "@/utils/wxShare";
// @ is an alias to /src
import focus from "@/components/index/focus.vue";
import votelist from "@/components/index/votelist.vue";
import newslist from "@/components/index/newslist.vue";
import resultlist from "@/components/index/resultList.vue";
import bannerBar from "@/components/index/bannerBar.vue";
import { getUrlPara } from "@/assets/js/voteComm.js";
export default {
  name: "index",
  components: {
    focus,
    votelist,
    newslist,
    resultlist,
    bannerBar,
    // vanSticky: Sticky,
    vanTabs: Tabs,
    vanTab: Tab,
  },
  data() {
    return {
      active: 0,
      focusData: {},
      listData: [],
      bottomBannerShow: false,
      bottomBannerData: {},
      specTitle: "000",
    };
  },
  methods: {
    getDatalist() {
      let url = `/api/spec/share/body/${this.urlId}`;
      axios
        .get(url)
        .then((res) => {
          // console.log(res);
          this.listData = res.data.data;
          const bottomIndex = this.listData.findIndex(
            (item) => item.module_type == "4"
          ); //查找底部图片索引值
          if (bottomIndex != -1) {
            this.bottomBannerShow = true;
            this.bottomBannerData = this.listData[bottomIndex]; //底部图片
            this.listData.splice(bottomIndex, 1); //主体内容
          }
        })
        .catch((err) => {
          console.log(err);
          Toast.fail("请求错误，请联系管理员");
        });
    },

    getTopdata() {
      let url = `/api/spec/share/head/${this.urlId}`;
      axios
        .get(url)
        .then((res) => {
          // console.log(res.data);
          this.focusData = res.data.data;
          document.title = this.focusData.title;
          let dataForWeixin = {
            title: this.focusData.title,
            desc: this.focusData.introduction,
            imgUrl: this.focusData.headPicture,
          };
          getSignature(dataForWeixin);
        })
        .catch((err) => {
          console.log(err);
          Toast.fail("请求错误，请联系管理员");
        });
    },
  },
  mounted() {
    // this.container = this.$refs.container;
  },
  beforeCreate() {},
  created() {
    this.urlId = getUrlPara("id");
    this.getDatalist();
    this.getTopdata();
  },
};
</script>
<style scoped>
</style>
